<template>
  <section class="eva-page">
    <v-row>
      <v-col cols="12" offset="0" md="10" offset-md="1">
        <div class="eva-top">
          <v-breadcrumbs
            large
            :items="crumbs"
            divider="/"
            class="pl-0 eva-breadcrumbs"
          />

          <div class="eva-titlebar">
            <div class="eva-title">
              <v-icon color="primary" class="mr-2">
                mdi-clipboard-text-clock
              </v-icon>
              <span class="primary--text">Ficha de Ordem de Trabalho</span>
            </div>
          </div>
        </div>

        <v-card class="eva-card mt-6" elevation="10">
          <v-card-title class="eva-card__title primary white--text">
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="white">mdi-clipboard-edit-outline</v-icon>
              <span class="font-weight-bold">
                Ordem de Trabalho
              </span>
            </div>
          </v-card-title>

          <v-card-text class="pt-6">
            <v-progress-linear
              v-if="loading"
              indeterminate
              class="global-loader mb-4"
            />

            <template v-if="loading">
              <v-row>
                <v-col cols="12" md="6">
                  <v-skeleton-loader type="text" />
                </v-col>

                <v-col cols="12" md="6">
                  <v-skeleton-loader type="text" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-skeleton-loader type="text" />
                </v-col>
              </v-row>

              <v-row align="center" justify="space-around">
                <v-skeleton-loader type="button" />
              </v-row>
            </template>

            <OrdemTrabalho
              v-else
              method="update"
              :ordem-trabalho="ordemTrabalho"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import OrdemTrabalho from "@/components/OrdensTrabalho/OrdemTrabalho";
import OrdensTrabalhoAPI from "@/api/OrdensTrabalho.js";

export default {
  components: {
    OrdemTrabalho,
  },

  data: () => ({
    ordemTrabalho: null,
    loading: true,
  }),

  mounted() {
    if (!this.$store.getters.hasPermission(["super", "work_orders.update"])) {
      this.$router.push("/no-permission");
      return;
    }

    OrdensTrabalhoAPI.get(this.$route.params.id)
      .then(({ data }) => {
        this.ordemTrabalho = data;
      })
      .finally(() => {
        this.loading = false;
      });
  },

  computed: {
    crumbs() {
      return [
        {
          text: "Dashboard",
          disabled: false,
          to: "/admin",
          exact: true,
        },
        {
          text: "Listagem de ordens de trabalho",
          disabled: false,
          to: "/ordens-trabalho",
          exact: true,
        },
        {
          text: "Ficha de Ordem de Trabalho",
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    },
  },
};
</script>

<style scoped>
.eva-page {
  padding-bottom: 32px;
}

.eva-top {
  margin-top: 8px;
}

.eva-breadcrumbs :deep(.v-breadcrumbs__item) {
  font-size: 13px;
}

.eva-titlebar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.eva-title {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.eva-card {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.eva-card__title {
  font-weight: 800;
  letter-spacing: 0.2px;
}
</style>
